import dynamic from "next/dynamic";
const SideBySideProductSwitcherWithProductTabsComponent = dynamic(()=>import("./side-by-side-product-switcher-with-product-tabs-component"));
import SideBySideProductSwitcherWithProductTabsConfig from "./side-by-side-product-switcher-with-product-tabs-config";
import SideBySideProductSwitcherWithProductTabsAdvancedConfig from "./side-by-side-product-switcher-with-product-tabs-advanced-config";
export default {
    SideBySideProductSwitcherWithProductTabsComponent,
    SideBySideProductSwitcherWithProductTabsConfig,
    SideBySideProductSwitcherWithProductTabsAdvancedConfig
};
